import { Suspense, useContext, useEffect } from "react";

import { ComponentSpinner } from "@components/spinner";
import Layout from "./layout";
import { Outlet } from "react-router-dom";
import { UserContext } from "@context/user";
import { checkForAdBlocker } from "@helpers/utils";

// ** Custom Component
const VerticalLayout = (props) => {
  const { loading, opsPaymentModel } = useContext(UserContext);
  useEffect(() => {
    checkForAdBlocker();
  }, []);
  return (
    <Suspense fallback={<ComponentSpinner />}>
      {/* Keyed on the Ops payment-model toggle: flipping it changes the
          `x-payment-model` header every request carries, so the page has to
          remount and refetch rather than keep showing the other model's data. */}
      <Layout {...props}>{loading ? <ComponentSpinner /> : <Outlet key={opsPaymentModel} />}</Layout>
    </Suspense>
  );
};

export default VerticalLayout;
